<template>
  <div class="thermo-first-law-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>ΔU = Q + W$</div>
    </div>

    <div class="main-layout vertical">
      <!-- 仿真区：活塞压缩与加热 -->
      <div class="canvas-item simulation">
         <svg width="100%" height="220" viewBox="0 0 400 220">
            <!-- 气缸 -->
            <rect x="100" y="40" width="200" height="140" fill="none" stroke="#ccc" stroke-width="2" />
            
            <!-- 活塞 -->
            <rect x="101" :y="40" width="198" :height="pistonY" fill="#2c3e50" opacity="0.8" />
            
            <!-- 气体分子 -->
            <circle v-for="i in 15" :key="i" 
              :cx="100 + (Math.random()*200)" 
              :cy="40 + pistonY + (Math.random()*(140-pistonY))" 
              r="3" :fill="getGasColor" />

            <!-- 热源 (火焰) -->
            <path v-if="heating" d="M 180 200 Q 200 160 220 200" fill="#ff4757" opacity="0.6" />
         </svg>

         <div class="hud-top">
            <div class="gauge">
               <label>内能增量 ΔU</label>
               <span class="val">{{ deltaU.toFixed(1) }} J</span>
            </div>
            <div class="gauge">
               <label>气体温度 T</label>
               <span class="val" :style="{ color: getGasColor }">{{ (temperature).toFixed(1) }} K</span>
            </div>
         </div>
      </div>

      <!-- 参数控制 -->
      <div class="bottom-controls">
         <div class="control-card glass">
            <div class="row">
               <div class="col">
                  <label>活塞位置 (做功 W)</label>
                  <el-slider v-model="pistonY" :min="0" :max="100" size="mini"></el-slider>
               </div>
               <div class="col-btn">
                  <label>加热 (吸收热量 Q)</label>
                  <el-button :type="heating ? 'danger' : 'info'" size="mini" @mousedown.native="startHeat" @mouseup.native="stopHeat">按住加热</el-button>
               </div>
            </div>
         </div>

         <div class="law-box">
            <p><strong>第一定律：</strong>改变系统内能有两种方式：<strong>做功 W</strong> 和 <strong>热传递 Q</strong>。外界对系统压缩（W>0）或系统吸热（Q>0）都会导致<strong>内能 ΔU</strong> 增加，表现为温度升高。</p>
         </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ThermodynamicsFirstLawViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      pistonY: 50,
      heating: false,
      temperature: 300,
      running: true
    }
  },
  computed: {
    deltaU() { return (this.temperature - 300) * 0.5; },
    getGasColor() {
       const ratio = (this.temperature - 300) / 200;
       return `rgb(${Math.min(255, 100 + ratio*155)}, ${Math.max(0, 210 - ratio*210)}, ${Math.max(0, 255 - ratio*255)})`;
    }
  },
  methods: {
    startHeat() { this.heating = true; },
    stopHeat() { this.heating = false; },
    animate() {
       if (!this.running) return;
       
       // Piston compression increases temperature (W)
       // Let's use a change-based logic. 
       // For simplicity, we just relate temp to pistonY and heating
       const targetTemp = 300 + (100 - this.pistonY) + (this.heating ? 150 : 0);
       this.temperature = this.temperature * 0.95 + targetTemp * 0.05;

       requestAnimationFrame(this.animate);
    }
  },
  mounted() { this.animate(); },
  beforeDestroy() { this.running = false; }
}
</script>

<style scoped lang="scss">
.thermo-first-law-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.viz-header { display: flex; justify-content: space-between; align-items: center; .title { font-size: 1rem; color: #fff; } .formula-chip { color: #ff4757; background: rgba(255,71,87,0.1); padding: 4px 12px; border-radius: 8px; font-weight: bold; } }
.canvas-item { 
   background: #000; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05);
   .hud-top { position: absolute; top: 15px; left: 15px; display: flex; gap: 20px;
      .gauge { background: rgba(0,0,0,0.6); padding: 5px 12px; border-radius: 6px; border-bottom: 2px solid #ff4757; label { display: block; font-size: 0.55rem; color: #888; } span { font-size: 0.9rem; color: #fff; font-family: monospace; } }
   }
}
.bottom-controls { flex: 0.5; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; .row { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; .col-btn { display: flex; flex-direction: column; } label { font-size: 0.7rem; color: #888; display: block; margin-bottom: 5px; } } }
.law-box { background: rgba(255, 71, 87, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
